const d = [
    {
        type: 'Feature',
        properties: {
            unique_id: '410328110',
            ext_path: '河南省 洛阳市 洛宁县 长水乡',
            cid: '1',
            pid: '410328',
            name: '长水乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.415858, 34.408792]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410328216',
            ext_path: '河南省 洛阳市 洛宁县 陈吴乡',
            cid: '2',
            pid: '410328',
            name: '陈吴乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.673696, 34.274569]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410328100',
            ext_path: '河南省 洛阳市 洛宁县 城关镇',
            cid: '3',
            pid: '410328',
            name: '城关镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.663873, 34.391458]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410328200',
            ext_path: '河南省 洛阳市 洛宁县 城郊乡',
            cid: '4',
            pid: '410328',
            name: '城郊乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.693616, 34.399615]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410328213',
            ext_path: '河南省 洛阳市 洛宁县 底张乡',
            cid: '5',
            pid: '410328',
            name: '底张乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.508708, 34.248435]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410328106',
            ext_path: '河南省 洛阳市 洛宁县 东宋镇',
            cid: '6',
            pid: '410328',
            name: '东宋镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.659488, 34.494972]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410328108',
            ext_path: '河南省 洛阳市 洛宁县 故县镇',
            cid: '7',
            pid: '410328',
            name: '故县镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.231202, 34.258847]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410328104',
            ext_path: '河南省 洛阳市 洛宁县 河底镇',
            cid: '8',
            pid: '410328',
            name: '河底镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.751145, 34.552975]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410328217',
            ext_path: '河南省 洛阳市 洛宁县 涧口乡',
            cid: '9',
            pid: '410328',
            name: '涧口乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.750422, 34.302914]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410328209',
            ext_path: '河南省 洛阳市 洛宁县 罗岭乡',
            cid: '10',
            pid: '410328',
            name: '罗岭乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.360664, 34.372662]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410328107',
            ext_path: '河南省 洛阳市 洛宁县 马店镇',
            cid: '11',
            pid: '410328',
            name: '马店镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.498479, 34.423381]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410328012',
            ext_path: '河南省 洛阳市 洛宁县 山底乡',
            cid: '12',
            pid: '410328',
            name: '山底乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.561958, 34.180028]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410328102',
            ext_path: '河南省 洛阳市 洛宁县 上戈镇',
            cid: '13',
            pid: '410328',
            name: '上戈镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.258153, 34.365864]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410328101',
            ext_path: '河南省 洛阳市 洛宁县 王范回族镇',
            cid: '14',
            pid: '410328',
            name: '王范回族镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.629679, 34.390572]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410328015',
            ext_path: '河南省 洛阳市 洛宁县 西山底乡',
            cid: '15',
            pid: '410328',
            name: '西山底乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.557888, 34.284359]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410328103',
            ext_path: '河南省 洛阳市 洛宁县 下峪镇',
            cid: '16',
            pid: '410328',
            name: '下峪镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.342842, 34.176086]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410328205',
            ext_path: '河南省 洛阳市 洛宁县 小界乡',
            cid: '17',
            pid: '410328',
            name: '小界乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.57175, 34.471998]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410328105',
            ext_path: '河南省 洛阳市 洛宁县 兴华镇',
            cid: '18',
            pid: '410328',
            name: '兴华镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.435565, 34.227238]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410328109',
            ext_path: '河南省 洛阳市 洛宁县 赵村镇',
            cid: '19',
            pid: '410328',
            name: '赵村镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.612551, 34.258621]
        }
    }
];

export { d };
// {
//     "type": "Feature",
//     "properties": {
//         "unique_id": "410328003",
//         "ext_path": "河南省 洛阳市 洛宁县 城关镇",
//         "cid": "3",
//         "pid": "410328",
//         "name": "城关镇",
//         "last_time": "2018-01"
//     },
//     "geometry": {
//         "type": "Point",
//         "coordinates": [
//             111.663873,
//             34.391458
//         ]
//     }
// },
// {
//     "type": "Feature",
//     "properties": {
//         "unique_id": "410328004",
//         "ext_path": "河南省 洛阳市 洛宁县 城郊乡",
//         "cid": "4",
//         "pid": "410328",
//         "name": "城郊乡",
//         "last_time": "2018-01"
//     },
//     "geometry": {
//         "type": "Point",
//         "coordinates": [
//             111.693616,
//             34.399615
//         ]
//     }
// },
// {
//     "type": "Feature",
//     "properties": {
//         "unique_id": "410328005",
//         "ext_path": "河南省 洛阳市 洛宁县 底张乡",
//         "cid": "5",
//         "pid": "410328",
//         "name": "底张乡",
//         "last_time": "2018-01"
//     },
//     "geometry": {
//         "type": "Point",
//         "coordinates": [
//             111.508708,
//             34.248435
//         ]
//     }
// },
// {
//     "type": "Feature",
//     "properties": {
//         "unique_id": "410328006",
//         "ext_path": "河南省 洛阳市 洛宁县 东宋镇",
//         "cid": "6",
//         "pid": "410328",
//         "name": "东宋镇",
//         "last_time": "2018-01"
//     },
//     "geometry": {
//         "type": "Point",
//         "coordinates": [
//             111.659488,
//             34.494972
//         ]
//     }
// },
// {
//     "type": "Feature",
//     "properties": {
//         "unique_id": "410328007",
//         "ext_path": "河南省 洛阳市 洛宁县 故县镇",
//         "cid": "7",
//         "pid": "410328",
//         "name": "故县镇",
//         "last_time": "2018-01"
//     },
//     "geometry": {
//         "type": "Point",
//         "coordinates": [
//             111.231202,
//             34.258847
//         ]
//     }
// },
// {
//     "type": "Feature",
//     "properties": {
//         "unique_id": "410328008",
//         "ext_path": "河南省 洛阳市 洛宁县 河底镇",
//         "cid": "8",
//         "pid": "410328",
//         "name": "河底镇",
//         "last_time": "2018-01"
//     },
//     "geometry": {
//         "type": "Point",
//         "coordinates": [
//             111.751145,
//             34.552975
//         ]
//     }
// },
// {
//     "type": "Feature",
//     "properties": {
//         "unique_id": "410328009",
//         "ext_path": "河南省 洛阳市 洛宁县 涧口乡",
//         "cid": "9",
//         "pid": "410328",
//         "name": "涧口乡",
//         "last_time": "2018-01"
//     },
//     "geometry": {
//         "type": "Point",
//         "coordinates": [
//             111.750422,
//             34.302914
//         ]
//     }
// },
// {
//     "type": "Feature",
//     "properties": {
//         "unique_id": "410328010",
//         "ext_path": "河南省 洛阳市 洛宁县 罗岭乡",
//         "cid": "10",
//         "pid": "410328",
//         "name": "罗岭乡",
//         "last_time": "2018-01"
//     },
//     "geometry": {
//         "type": "Point",
//         "coordinates": [
//             111.360664,
//             34.372662
//         ]
//     }
// },
// {
//     "type": "Feature",
//     "properties": {
//         "unique_id": "410328011",
//         "ext_path": "河南省 洛阳市 洛宁县 马店镇",
//         "cid": "11",
//         "pid": "410328",
//         "name": "马店镇",
//         "last_time": "2018-01"
//     },
//     "geometry": {
//         "type": "Point",
//         "coordinates": [
//             111.498479,
//             34.423381
//         ]
//     }
// },
// {
//     "type": "Feature",
//     "properties": {
//         "unique_id": "410328012",
//         "ext_path": "河南省 洛阳市 洛宁县 山底乡",
//         "cid": "12",
//         "pid": "410328",
//         "name": "山底乡",
//         "last_time": "2018-01"
//     },
//     "geometry": {
//         "type": "Point",
//         "coordinates": [
//             111.561958,
//             34.180028
//         ]
//     }
// },
// {
//     "type": "Feature",
//     "properties": {
//         "unique_id": "410328013",
//         "ext_path": "河南省 洛阳市 洛宁县 上戈镇",
//         "cid": "13",
//         "pid": "410328",
//         "name": "上戈镇",
//         "last_time": "2018-01"
//     },
//     "geometry": {
//         "type": "Point",
//         "coordinates": [
//             111.258153,
//             34.365864
//         ]
//     }
// },
// {
//     "type": "Feature",
//     "properties": {
//         "unique_id": "410328014",
//         "ext_path": "河南省 洛阳市 洛宁县 王范回族镇",
//         "cid": "14",
//         "pid": "410328",
//         "name": "王范回族镇",
//         "last_time": "2018-01"
//     },
//     "geometry": {
//         "type": "Point",
//         "coordinates": [
//             111.629679,
//             34.390572
//         ]
//     }
// },
// {
//     "type": "Feature",
//     "properties": {
//         "unique_id": "410328015",
//         "ext_path": "河南省 洛阳市 洛宁县 西山底乡",
//         "cid": "15",
//         "pid": "410328",
//         "name": "西山底乡",
//         "last_time": "2018-01"
//     },
//     "geometry": {
//         "type": "Point",
//         "coordinates": [
//             111.557888,
//             34.284359
//         ]
//     }
// },
// {
//     "type": "Feature",
//     "properties": {
//         "unique_id": "410328016",
//         "ext_path": "河南省 洛阳市 洛宁县 下峪镇",
//         "cid": "16",
//         "pid": "410328",
//         "name": "下峪镇",
//         "last_time": "2018-01"
//     },
//     "geometry": {
//         "type": "Point",
//         "coordinates": [
//             111.342842,
//             34.176086
//         ]
//     }
// },
// {
//     "type": "Feature",
//     "properties": {
//         "unique_id": "410328017",
//         "ext_path": "河南省 洛阳市 洛宁县 小界乡",
//         "cid": "17",
//         "pid": "410328",
//         "name": "小界乡",
//         "last_time": "2018-01"
//     },
//     "geometry": {
//         "type": "Point",
//         "coordinates": [
//             111.57175,
//             34.471998
//         ]
//     }
// },
// {
//     "type": "Feature",
//     "properties": {
//         "unique_id": "410328018",
//         "ext_path": "河南省 洛阳市 洛宁县 兴华镇",
//         "cid": "18",
//         "pid": "410328",
//         "name": "兴华镇",
//         "last_time": "2018-01"
//     },
//     "geometry": {
//         "type": "Point",
//         "coordinates": [
//             111.435565,
//             34.227238
//         ]
//     }
// },
// {
//     "type": "Feature",
//     "properties": {
//         "unique_id": "410328019",
//         "ext_path": "河南省 洛阳市 洛宁县 赵村镇",
//         "cid": "19",
//         "pid": "410328",
//         "name": "赵村镇",
//         "last_time": "2018-01"
//     },
//     "geometry": {
//         "type": "Point",
//         "coordinates": [
//             111.612551,
//             34.258621
//         ]
//     }
// },
